import { render, staticRenderFns } from "./info-circle.vue?vue&type=template&id=070f20f3&"
import script from "./info-circle.vue?vue&type=script&lang=js&"
export * from "./info-circle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports